module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAPCAYAAAALWoRrAAAAAXNSR0IArs4c6QAAAVhJREFUOE+10j8vg1EUBvDnOW8bRNgNRquwSFoLQYlQ7EYiYRIfgE+ACIn4s/gOujBJmhh8DwaztG97zyMtryLalMadbm7O+eXJOZcAcDkzngc1Wrt3ciS/Xbu5L/Isl8karNgJ1uiVV4ABXuWGe8vet07DQUewVBG47CoVeT6T3YG8QIvmAOz/DVYscSWS0g4N8TKX3RW4wQomlcb872HFoC2FqsqRoeDAdoLuAXiswymfA+2wvcSK3ZWPZLEMBRDdgjY/ozWnDoe0cgYetYIFlAEsWkA1AWv1P6EfsKc4Teq4CVyywEVBAYZrET1JXTP0A1ZaUwBPvsBCCfCF4Oapb2CrpInxPmNMgDh9e9QLyQVUge8J20n6BQ6mfkbIkCqwaoPNwHaSJvAT5KtB8UPErjzAs9qWmy2x1Uzb+1E/VP0L6tAWL2YzY5DdAej6c7zGlp4rwUdeAVwJvDwXuewbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_mail_red.png
// module id = LvGh
// module chunks = 1